const getNumberByString = (string: string) =>
    string.split('').reduce((previousValue, currentValue) => {
        const code = currentValue.charCodeAt(0);
        return previousValue + code / 10 ** code.toString().length;
    }, 0);

export function getColorsBySeed(seed: string) {
    // Predefined secondary colors to choose from
    const secondaryColors = [
        '#371367',
        '#1C5E51',
        '#6B5D10',
        '#1C5F2B',
        '#601C1A',
        '#664014',
        '#123768',
    ];

    const numberBySeed = getNumberByString(seed);

    // Select secondary color from predefined palette based on seed
    const colorIndex = Math.floor(Math.abs(Math.sin(numberBySeed)) * secondaryColors.length);
    const secondaryColor = secondaryColors[colorIndex];

    return {
        mainColor: '#FFFFFF',
        secondaryColor,
    };
}
